export default __webpack_public_path__ + "2ef15f78bcc7262fdefbfc8e7df77103.png";